module.exports = __webpack_public_path__ + "static/media/semanticscholar.cf15952e.svg";